import { Button } from '@/components/ui/button.tsx'
import { cn } from '@/lib/utils.ts'
import type * as React from 'react'

type Props = {
  displayText: string
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
  className?: string
}

export const DropdownItem = ({ displayText, onClick, className }: Props) => {
  return (
    <Button
      type="button"
      variant="ghost"
      className={cn(
        'text-left justify-start h-[26px] font-EN-KR-caption-regular text-contents-primary w-full py-1.5 px-2 rounded-none',
        className,
      )}
      onClick={onClick}
    >
      {displayText}
    </Button>
  )
}
